import React, { useEffect } from "react";
import Spinner from "../components/Spinner";

import { useNavigate, useParams } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();
	const params = useParams();

  useEffect(() => {
  	if(params.token){
  		localStorage.setItem('client', JSON.stringify({token: params.token}));
		  localStorage.setItem('admin', 'false');
  	}
  	window.location.href = "/surveys"
  }, [])
  return (
    <div>
      <Spinner />
    </div>
  );
};

export default Dashboard;
